export const PLATFORM_ENDPOINTS = {
    ANONYMOUS: "GetTokenBySiteId",
    RENEW: "renew-token",
    LOGOUT: "logout",
    ONE_TIME_TOKEN: "onetimetoken-login"
};
export const SEAMLESS_ENDPOINTS = {
    ANONYMOUS: "anonymous",
    LOGIN: "login",
    RENEW: "renew",
    LOGOUT: "logout"
};
export const WALLET_ENDPOINTS = {
    ANONYMOUS: "users/anonymous",
    LOGIN: "users/login",
    RENEW: "users/renew"
};
//# sourceMappingURL=requestService.js.map